<template>
  <llp-page
    id="datatble-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
        <div class="card-body">
          <div class="row p-0">
            <div class="col p-4">
              <h4>Commissions</h4>
            </div>
          </div>
          <div class="row p-2">
            <div class="col-lg-3 col-md-6 col-sm-6" v-if="isAdminOrSuperAdmin">
               <llp-label id="confirmPasswordLabel">Admin:</llp-label>
                    <llp-input
                      id="confirmpassword"
                      class="w-100"
                      autocomplete="off"
                      v-model="adminCommission"
                    ></llp-input>
            </div>
                 <div class="col-lg-3 col-md-6 col-sm-6">
               <llp-label id="confirmPasswordLabel">Distributor:</llp-label>
                    <llp-input
                      id="confirmpassword"
                      class="w-100"
                      autocomplete="off"
                      v-model="distributorCommission"
                    ></llp-input>
            </div>     
             <div class="col-lg-1 col-sm-6 col-md-4 mt-3 charges-btn">
              <llp-button
                :load-spinner="showaddadminSpinner"
                classNames="btn-secondary new-btn"
                @click="save()"
              >
                Save
              </llp-button>
            </div>
          </div>
        </div>
      </div>
      </div>
      
    </template>
  </llp-page>
  <llp-toast ref="toast"></llp-toast>
</template>

<script>
import NetworkService from '@/services/network.service';
export default {
  data() {
    return {
      role_id:localStorage.getItem('role_id'),
      user_id:localStorage.getItem('User_id'),
      adminCommission: '',
      distributorCommission: '',
      showaddadminSpinner: false,
      commssions:[]
    };
  },
  computed: {
    isAdminOrSuperAdmin() {
      return (this.role_id == "1");
    },
    
  },
  mounted()
  {
this.fetchingCommissionCharges()
  },
  methods: {

async fetchingCommissionCharges() {
  try {
    
    const role_id = this.role_id;

    let endpoint = 'get-superadmin-charges';
    if (role_id == "2" && this.user_id) {
      endpoint += `/${this.user_id}`;
    }
    const response = await NetworkService.get(endpoint);
    if (this.role_id == "1") {
      response.data.forEach(item => {
        if (item.role_id == 2) {
          this.adminCommission = item.admin_charges || '';
        } else if (item.role_id == 3) {
          this.distributorCommission = item.distributor_commission || '';
        }
      });
    } else if (this.role_id == "2") {
     const item = response.data[0];
      this.distributorCommission = item?.distributor_commission || '';
      
    }

  } catch (error) {
    this.$refs.toast.show(
      "Unable to fetch the commissions",
      "error"
    );
  }
},

    async save() {
  this.showaddadminSpinner = true;
  let payload = {};
  if (this.role_id == "1") {
    payload = {
      charges: [
        {
          id: 1, 
          role_id: 2,
          admin_charges: this.adminCommission,
          distributor_commission: null
        },
        {
          id: 2, 
          role_id: 3,
          admin_charges: null,
          distributor_commission: this.distributorCommission
        }
      ]
    };
  } else if (this.role_id == "2") {
  
   payload = {
  charges: [
    {
      user_id: this.user_id,
      role_id: this.role_id,
      distributor_commission: this.distributorCommission
    }
  ]
};

  }
  try {
    const response = await NetworkService.post('update-superadmin-charges', payload);
    this.$refs.toast.show(response.data.message,"success");
  } catch (error) {
    this.$refs.toast.show("Update failed. Please try again.","error");
  } finally {
    this.showaddadminSpinner = false;
  }
}

  }
};
</script>
